/** Official Bulandi 2026 competition round dates (July Sundays). */
export const BULANDI_EVENT_SCHEDULE_BY_ID = {
  "mic-drop-intermediates": ["2026-07-12"],
  "mic-drop-seniors": ["2026-07-12"],
  "mind-maze-seniors": ["2026-07-05"],
  "foot-loose-juniors": ["2026-07-05", "2026-07-12"],
  "foot-loose-intermediates": ["2026-07-05", "2026-07-12"],
  "brain-burn-intermediates": ["2026-07-05"],
  "funk-fusion-seniors": ["2026-07-05", "2026-07-12"],
  "verse-vibes-juniors": ["2026-07-12"],
  "wanna-b-picasso-juniors": ["2026-07-19"],
  "profit-or-laugh-seniors": ["2026-07-12"],
  "tale-spin-intermediates": ["2026-07-12"],
  "riddle-rush-juniors": ["2026-07-12"],
  "knives-out-intermediates": ["2026-07-19"],
  "knives-out-seniors": ["2026-07-19"],
  "nitro-rush-intermediates": ["2026-07-19"],
  "sher-lock-key-seniors": ["2026-07-19"],
  "wanna-b-picasso-intermediates": ["2026-07-19"],
  "tote-studio-seniors": ["2026-07-19"],
  "ink-it-intermediates": ["2026-07-19"],
  "ink-it-seniors": ["2026-07-19"],
  "clash-of-clans-family": ["2026-07-19"],
};

const MONTH_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** @param {string} iso yyyy-mm-dd */
function parseScheduleIso(iso) {
  const [y, m, d] = String(iso).split("-").map((x) => parseInt(x, 10));
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
  return { year: y, month: m, day: d };
}

/**
 * Human-readable schedule label for an event tile, e.g. "Jul 5, 2026" or "Jul 5 & 12, 2026".
 * @param {string} eventId
 * @returns {string | null}
 */
export function formatBulandiEventScheduleLabel(eventId) {
  const dates = BULANDI_EVENT_SCHEDULE_BY_ID[eventId];
  if (!Array.isArray(dates) || dates.length === 0) return null;

  const parsed = dates.map(parseScheduleIso).filter(Boolean);
  if (parsed.length === 0) return null;

  const { year, month } = parsed[0];
  const monthLabel = MONTH_SHORT[month - 1] || "";
  if (!monthLabel) return null;

  if (parsed.length === 1) {
    return `${monthLabel} ${parsed[0].day}, ${year}`;
  }

  const sameMonth = parsed.every((p) => p.month === month && p.year === year);
  if (sameMonth) {
    const days = parsed.map((p) => p.day).join(" & ");
    return `${monthLabel} ${days}, ${year}`;
  }

  return parsed
    .map((p) => `${MONTH_SHORT[p.month - 1] || ""} ${p.day}, ${p.year}`)
    .join(" · ");
}
